import { HashRouter as Router, Routes, Route } from 'react-router-dom'; 
import './App.css';

import AddMoney from './Pages/AddMoney';
import DepositRec from './Pages/DepositRec';
import Home from './Pages/Home';
import Payouts from './Pages/Payouts';
import UsersRec from './Pages/UsersRec';


import Login from './Pages/Login';
import WithdrawRec from './Pages/WithdrawRec';
import ApproveFund from './Pages/ApproveFund';
import AgentWithdrawal from './Pages/AgentWithdrawal';
import Receipt from './Pages/Receipt';
import AgentHome from './Pages/AgentHome';
import PendingDeposit from './Pages/PendingDeposit';

import { useAuth } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AgentDeposit from './Pages/AgentDeposit';
import AgentWithdrawalRec from './Pages/AgentWithdrawalRec';
import Fixtures from './Pages/Fixtures';
import BetRecords from './Pages/BetRecords';
import UserData from './Pages/UserData'

function App() {
  const { user } = useAuth();

  const routesConfig = [
    { path: '/index/home', component: user && user.role === 'admin' ? Home : AgentHome, protected: true },
    { path: '/', component: user && user.role === 'admin' ? Home : AgentHome, protected: true },
    { path: '/records/users', component: UsersRec, protected: true },
    { path: '/user/record', component: UserData, protected: true },
    { path: '/records/bets', component: BetRecords, protected: true },
    { path: '/records/deposits', component: user && user.role === 'admin' ? DepositRec : AgentDeposit, protected: true },
    { path: '/records/payouts', component: user && user.role === 'admin' ? WithdrawRec : AgentWithdrawalRec, protected: true },
    { path: '/pending/withdrawal', component: user && user.role === 'admin' ? Payouts : AgentWithdrawal, protected: true },
    { path: '/pending/deposit', component: PendingDeposit, protected: true },
    { path: '/fixtures', component: Fixtures, protected: true },
    { path: '/withdraw/slip', component: Receipt, protected: true },
    { path: '/update/balance', component: AddMoney, protected: true },
    { path: '/approve/funds', component: AgentWithdrawal, protected: true },
    { path: '/user/login', component: Login, protected: false },
  ];

    return (
    <div className="App">
      <Router>
        <Routes>
          {routesConfig.map(({ path, component: Component, protected: isProtected }) => (
            <Route
              key={path}
              path={path}
              element={
                isProtected ? (
                  <ProtectedRoute>
                    <Component />
                  </ProtectedRoute>
                ) : (
                  <Component />
                )
              }
            />
          ))}
        </Routes>
      </Router>
    </div>
  );
}

export default App;